import type { KAPLAYCtx } from "kaplay";
import * as C from "./constants";

export interface CameraSystem {
  update(victorySequenceActive: boolean): void;
}

export function createCameraSystem(k: KAPLAYCtx, player: any): CameraSystem {
  const cameraOffsetX =
    player.pos.x + C.PLAYER_HORIZONTAL_POSITION * C.GRID_CELL_SIZE;
  const deadZoneTop = C.CAMERA_DEADZONE_TOP * C.GRID_CELL_SIZE;
  const deadZoneBottom = C.CAMERA_DEADZONE_BOTTOM * C.GRID_CELL_SIZE;

  const screenHeight = k.height();
  const initialCameraY = player.pos.y - screenHeight / 3;
  k.setCamPos(cameraOffsetX, initialCameraY);
  k.setCamScale(Math.sqrt(k.width() / C.REFERENCE_WIDTH));

  return {
    update(victorySequenceActive: boolean) {
      if (!victorySequenceActive) {
        const currentCamY = k.getCamPos().y;
        const playerScreenY = player.pos.y - currentCamY;
        const screenCenterY = 0;

        let targetCamY = currentCamY;

        if (playerScreenY > screenCenterY + deadZoneTop) {
          targetCamY = player.pos.y - deadZoneTop;
        } else if (playerScreenY < screenCenterY - deadZoneBottom) {
          targetCamY = player.pos.y + deadZoneBottom;
        }

        k.setCamPos(
          cameraOffsetX,
          k.lerp(currentCamY, targetCamY, C.CAMERA_SMOOTHING),
        );
      }
    },
  };
}
